class SecurityDepositCancelModal {
    /** @ngInject */
    constructor($state, ContactTelephone, Contract, SecurityDeposit, ErrorCatcher) {
        this.$state = $state
        this.ContactTelephone = ContactTelephone
        this.Contract = Contract
        this.SecurityDeposit = SecurityDeposit
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.state = 'STATE-CANCEL-FORM'
    }

    confirmCancelContract() {
        this.state = 'STATE-CANCEL-PROGRESS'
        let cancelContractPromise
        if (this.resolve.tokenId) {
            cancelContractPromise = this.SecurityDeposit.refuseDeposit({ tokenId: this.resolve.tokenId }, {}).$promise
        } else {
            cancelContractPromise = this.Contract.cancelContract({ id: this.resolve.contractId }, {}).$promise
        }
        cancelContractPromise.then(() => {
            this.$state.go('landing')
            this.state = 'STATE-CANCEL-DONE'
        }).catch((error) => {
            this.state = 'STATE-CANCEL-ERROR'
            this.ErrorCatcher.catchError(error)
        })
    }
}

export default {
    template: require('./securityDepositCancelModal.jade')(),
    controller: SecurityDepositCancelModal,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/securityDepositSummary/modal/securityDepositCancelModal.js